const state = {
	partnerStatus: [{
		label: '开启',
		value: 0
	}, {
		label: '拒绝',
		value: 1
	}, {
		label: '待认证',
		value: 2
	}],
	userTypes: [
		// {
		// 	label: '会员',
		// 	value: 'MEMBER'
		// }, 
		// {
		// 	label: '管理员',
		// 	value: 'ADMIN'
		// }, 
		{
			label: '商家',
			value: 'MERCHANT'
		}, 
		{
			label: '公司',
			value: 'CARGO_AGENT'
		},
		// {
		// 	label: '货代业务员',
		// 	value: 'CARGO_AGENT_STAFF'
		// }, 
		{
			label: '个人',
			value: 'PARTNER'
		},
	],
	userSource: [{
		label: '年度预注册',
		value: 0
	}, {
		label: '合作伙伴申请',
		value: 3
	}]
}
export default state